import React from "react";
import {Container, DarkBackground, Link, Logo} from "./Header.css";
import logo from '/assets/brand.png?url';
import {HideOnMobile} from "../../global.css";
import {useLocation, useNavigate} from "react-router-dom";

function Header() {

    const navigate = useNavigate()
    const { pathname } = useLocation();
console.log(pathname)
    return (
        <div className={`${Container} ${pathname !== "/home" ? DarkBackground : ""}`}>
            <img src={logo} className={Logo}  alt={"Logo"}/>
            <span className={HideOnMobile}>|</span>
            <span className={HideOnMobile}>API PORTAL</span>
            <button className={Link} onClick={() => navigate("/home")}>Nos produits</button>
            <button className={Link} onClick={() => navigate("/home/contact")}>Nous contacter</button>
        </div>
    );
}

export default Header;